<div>
  <tmo-container-holder
    *ngIf="authorableData"
    [isDynamicContent]="authorableData"
  ></tmo-container-holder>
  <div class="row" *ngIf="contentData?.plansAndServicesDescription">
    <div class="col-12 m-t-lg">
      <tmo-see-more-see-less
        id="see-more"
        [limit]="140"
        [seeMoreText]="contentData?.seeMore"
        [seeLessText]="contentData?.seeLess"
      >
      </tmo-see-more-see-less>
    </div>
  </div>
  <div class="row" *ngIf="showOnLineDetails">
    <div class="col-12 buttons-container-vertical button-spacing">
      <div class="button-box" *ngIf="pendingOrdersModal">
        <button
          class="btn btn-primary"
          (click)="openEditPlanService()"
          id="Edit-plan-and-services"
          [disabled]="
            isTouristPlan || lineStatus === PLAN_SERVICE_CONSTANTS.CANCELLED || !permissionEnabled
          "
        >
          {{ contentData?.editPlansAndServices }}
        </button>
      </div>

      <div class="button-box" *ngIf="billingType">
        <button
          class="btn btn-secondary"
          id="add-session-passes"
          tmoUIPermission
          [targetName]="permissionConstants.PURCHASE_SESSION_PASSES"
          (click)="routeEvent($event); setPreviousUrl(routerConstants.LINE_LANDING)"
          [disabled]="isTouristPlan || lineStatus !== PLAN_SERVICE_CONSTANTS.ACTIVE"
        >
          {{ contentData?.addSessionPasses }}
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="broadbandFactsUrl && broadbandFactsUrl !== error" class="text-magenta underline col-12 text-center m-b-lg p-b-md">
    <a class="f-w-700 f-s-16" href="{{broadbandFactsUrl}}" target="_blank">{{contentData?.checkBroadbandFacts}}</a>
  </div>
  <div *ngIf="broadbandFactsUrl === error" class="m-b-lr text-center">
    <p>{{contentData?.bblErrorMessage}}</p>
  </div>
  <ng-container>
    <tmo-static-modal
      [modal]="modal"
      (onClose)="closeModal()"
      (onSelect)="handleClickEvent($event, true)"
    ></tmo-static-modal>
    <tmo-static-modal
      [modal]="mixedCartModal"
      (onSelect)="handleCartModalClickEvent($event)"
    ></tmo-static-modal>
  </ng-container>
  <tmo-spinner [setDelay]="!showSpinner"></tmo-spinner>
</div>
